import React, { useEffect } from "react";
import "./styles/dashboard.css";
import FeatureBox from "../../components/FeatureBox";


const Dashboard = () => {
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
  const content = [
    {
      img: '/images/real.svg',
      title: "Real-Time Analytics",
      content: "Instantly track total users, completed surveys, attempts, and earnings — all in one place.",
    },
    {
      img: '/images/conversion.svg',
      title: "Revenue Insights",
      content: "Discover how users interact with surveys and identify optimization opportunities.",
    },
    {
      img: '/images/simple.svg',
      title: "Simple Interface",
      content: "Navigate easily through sections like statistics, app list, postbacks, chargebacks, and payouts.",
    },
   
  ];
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
     <div className="container dashboard-container">
      <h1 className="dash-heading">
      Powerful Dashboard. Total Control.
      </h1>
      <p className="dash-para">
      Real Opinion’s Dashboard puts all your app’s monetization metrics in one intuitive, easy-to-navigate interface.
      </p>
     
    </div>
    <div className="dashboard-box-container">
        {content.map((val, i) => (
          <FeatureBox
            key={i}
            gap={ screenWidth < 584 && "15px"}
            minWboxWidth={ screenWidth < 584 && "70%"}
            boxWidth= {screenWidth < 584 ? "400px" : "27%" }
            titleFontSize ={18}
            paraColor ={"rgba(220, 220, 220, 0.9)"}
            headingColor={"white"}
            transparent={true}
            imgSrc={val.img}
            title={val.title}
            content={val.content}
          />
        ))}
      </div>
    </>
   

  );
};

export default Dashboard;
